var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"home-featured-link",class:'link-' + _vm.game,style:({ 'height': _vm.homeHeight + 'px' }),attrs:{"to":'/' + _vm.game}},[_c('div',{staticClass:"link-featured"},[_vm._v("FEATURED")])])
}
var staticRenderFns = []

export { render, staticRenderFns }